module.exports = __webpack_public_path__ + "static/img/huaweiPadM6.87da2433.png";